import type { FaireProductEntity } from "../../entity_types/product";

export const p_ps44n7tqaj: FaireProductEntity = {
  token: "p_ps44n7tqaj",
  type: "product",
  name: "Men's Soft Athleisure Hoodie Lounge Pullover",
  brandToken: "b_br6ji29u",
  brandName: "Softies",
  imageUrl: "https://cdn.faire.com/fastly/11d437c4dad5ffbbd4bf1e6bdae4ec5551368c76e0a9ec23b3621300e5e445af.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7c73ea8fa67ef10972ccaa16cc2ca9ce309b9fe50b2e6d499f3ca1b5c6bf0d85.jpeg",
    "https://cdn.faire.com/fastly/86a64cd479bf4aee7677d2b41f3a59d7cbd3f3f2e5a154ce3e0393a91ee64050.jpeg",
    "https://cdn.faire.com/fastly/4f5fa6461b0782199cfe987556c3dfb8d8ab4d820f4fcacfd4ea894a748e84a6.jpeg",
    "https://cdn.faire.com/fastly/49871834c818dd49bac401724e5795bf9d7ed9405b5220b7c277e374097429c6.jpeg",
    "https://cdn.faire.com/fastly/28b9300f55b1cb9da878e51c137e812cc26bfed990904cc2ac69236a205d6249.jpeg",
    "https://cdn.faire.com/fastly/e96606a0881a578f58738732a66e01433b5e764951af68b42f7cf04ee8ba007d.jpeg",
    "https://cdn.faire.com/fastly/35e773c082c9ce369693d11a2cbbd626dba31309fc472609974109c9799461d1.jpeg",
    "https://cdn.faire.com/fastly/183e70cc7da34a72af36e1e7b2f5351feaf126069b0089e8d1ad14c480e7dfaa.jpeg",
    "https://cdn.faire.com/fastly/a074720cb81095840f5dc0eeb7c07f47b909d6931a5ee157fe38346cde25fe5c.jpeg",
    "https://cdn.faire.com/fastly/35a297bf907fc77894b6c85f868960ec198bb91abd144e30e918f2ededc9f7d4.jpeg",
    "https://cdn.faire.com/fastly/77ff20bba8015520b19f47fb1bc56e1b96367e0dcade3be6253b15f88986929c.jpeg",
    "https://cdn.faire.com/fastly/0a25a05a4a3684dbe85c0f0dfbd2d1aaa0896804eeba947fa921897cbcde0323.jpeg",
    "https://cdn.faire.com/fastly/0449fa103008256597c6b0eb6375104b6c8fe9412cd538610963b8333f617cfe.jpeg",
    "https://cdn.faire.com/fastly/bf059a841bf7797d7b3f4e4a5d4dd9144852e2dbc7e0e13af189f31c7804199a.jpeg",
    "https://cdn.faire.com/fastly/ee453e7d4ba8b5bf967b7104c6a143589c947e5344ca669e73fbfce4490c4f81.png"
  ],
  priceDollars: 50,
  description: "The Take 10 Men’s DreamTech Hoodie stands out with its softer hoodie material and practical quarter zip feature, making it an ideal golf pullover or a go-to for any casual outing. Its design focuses on performance wear fit, ensuring that your movement is never restricted.\n\nMade in our new DreamTech fabric, the hoodie has the softness of loungewear with the substance of athleisure. It boasts an athletic fit, with a wider cut in the shoulders and tapers towards the waist. Fitted with a drawstring for adjustable comfort and a kangaroo pocket for convenience, is the perfect sweater to take on the go.\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬\n• Pullover hoodie with kangaroo pocket\n• Athletic cut\n• Logo patch at hem\n\n𝐌𝐚𝐭𝐞𝐫𝐢𝐚𝐥𝐬 & 𝐂𝐚𝐫𝐞\n• Easy care, colorfast and machine washable\n• Softies DreamTech fabric is 81% rayon, 14% nylon, 5% spandex",
  tags: [],
  msrpDollars: 99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-02T03:47:10.524Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
